module.exports = __webpack_public_path__ + "static/media/day09_slider.0e73bea9.gif";